import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Header from './Header'
import Personal from './PersonalProgress'
import Victories from './Victories'
import Community from './Community'
import styles from './_mid2018.css'
import {
  selectCountryCode,
  selectLoggedIn,
  selectUserId,
  selectFirstName,
  selectUsername,
  selectUnitPreference,
} from 'services/user/selectors'
import * as yearInReviewActions from 'services/yearInReview/actions'

const mapStateToProps = (state) => ({
  isLoggedIn: selectLoggedIn(state),
  site: state.site,
  userCountry: selectCountryCode(state),
  userId: selectUserId(state),
  userUnitPreference: selectUnitPreference(state),
  userYear: state.yearInReview.userYearData,
  username: selectUsername(state),
  firstName: selectFirstName(state),
  showCommunityStats: state.yearInReview.showCommunityStats,
})

const mapDispatchToActions = { ...yearInReviewActions }

export class MidYear extends Component {
  static propTypes = {
    site: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      shortName: PropTypes.string,
    }),
    fetchUserYear: PropTypes.func.isRequired,
    firstName: PropTypes.string,
    toggleCommunityStats: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
    route: PropTypes.object,
    shareOnFacebook: PropTypes.func,
    shareOnTwitter: PropTypes.func,
    userCountry: PropTypes.string,
    userId: PropTypes.number,
    userUnitPreference: PropTypes.string,
    userYear: PropTypes.object,
    username: PropTypes.string,
    showCommunityStats: PropTypes.bool,
  }

  componentWillMount () {
    const {
      fetchUserYear,
      isLoggedIn,
      userId,
    } = this.props
    const year = '2018'

    if (isLoggedIn) {
      fetchUserYear(userId, year)
    }
  }

  handleFacebookShare = () => {
    const url = window.location.href
    this.props.shareOnFacebook(url)
  }

  handleTwitterShare = () => {
    const siteName = this.props.site.name
    const twitterPostText = `I used ${siteName} to make 2018 count. Check out how.`
    this.props.shareOnTwitter(twitterPostText)
  }

  render () {
    const {
      isLoggedIn,
      userCountry,
      userYear,
      username,
      userUnitPreference,
      firstName,
      toggleCommunityStats,
      showCommunityStats,
    } = this.props

    const showSponsor = !isLoggedIn || userCountry === 'US'

    return (
      <div className={styles.midyear}>
        <img
          width="0"
          height="0"
          src="https://ev.surveywall-api.survata.com/k?eid=e1db71e7-bb9d-47fc-b4d2-9fa2db92fb8e&cid=midyearhomepage,midyearhomepage,midyearhomepage,midyearhomepage,midyearhomepage"
        />
        <Header showSponsor={showSponsor} />
        <div className={styles.topoWrapper}>
          { isLoggedIn && userYear ?
            <Personal
              firstName={firstName}
              username={username}
              userYear={userYear}
              userUnitPreference={userUnitPreference}
              onFacebookShare={this.handleFacebookShare}
              onTwitterShare={this.handleTwitterShare}
            />
          : null }
          <Victories showSponsor={showSponsor} />
        </div>
        <div className={styles.topoWrapper}>
          <Community
            toggleCommunityStats={toggleCommunityStats}
            showCommunityStats={showCommunityStats}
            showSponsor={showSponsor}
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(MidYear)



// WEBPACK FOOTER //
// ./src/components/yearInReview/2018/midyear/index.js